import { Box, Typography, styled } from '@mui/material';
import { PageWrapper } from '../../common/styled';
import { StyledButton as ExamsStyledButton } from '../../Exams/styled';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';

export const PageContainer = styled(Box)(() => ({
  padding: '24px',
  paddingTop: '100px'
}));

export const SearchContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  justifyContent: 'start',
  '@media (max-width:586px)': {
    gap: 2,
    alignItems: 'start',
    flexDirection: 'column'
  }
}));

export const SearchItemContainer = styled(Box)(() => ({
  width: '170px',
  '@media (max-width:586px)': {
    width: '100%'
  }
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  marginTop: 24,
  justifyContent: 'flex-end',
  width: '100%'
}));

export const SubjectPageWrapper = styled(PageWrapper)(() => ({
  paddingTop: '16px !important'
}));

export const ActionsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 16,
  marginBottom: 8
}));

export const SubjectsButton = styled(ExamsStyledButton)(() => ({
  width: 'max-content'
}));

export const subjectDataGridSx = () => ({
  ...dataGridSx(pallet),
  '& .MuiDataGrid-virtualScroller': {
    overflowY: 'auto'
  }
});

export const CloneNoteText = styled(Typography)(() => ({
  marginBottom: 8
}));

export const CloneHighlightText = styled(Box)(() => ({
  fontWeight: 'bold'
}));

export const CloneSectionTitle = styled(Typography)(() => ({
  marginBottom: 8
}));

export const CloneFormContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8
}));
